import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PhysicalTherapyDoctor } from '../Models/physicaltherapydoctor.model';

@Injectable({
  providedIn: 'root'
})
export class PhysicalTherapyDoctorService {

 
  url = environment.Url+'PhysicalTherapyDoctors';
  drBooking = environment.Url + 'PhysicalTherapyDoctors/ptDoctorBookings';
  drUnAvailableDates = environment.Url + 'PhysicalTherapyDoctors/ptDoctorDates';


  header = new HttpHeaders({

    'Authorization': 'token' + localStorage.getItem('token')

  })

  constructor(private http: HttpClient) { }




  registerPhysicalTherapyDoctor(body){
    return this.http.post<PhysicalTherapyDoctor>(this.url,body).pipe(
     catchError(this.handleError)
   );
     }

   getPhysicalTherapyDoctors(){
    return this.http.get<PhysicalTherapyDoctor[]>(this.url).pipe(catchError(this.handleError)
    
    );
   }
   getPhysicalTherapyDoctorById(id){
    return this.http.get<PhysicalTherapyDoctor>(this.url+'/'+id)
  }
  getPTDoctorBooking(id) {
    return this.http.get<PhysicalTherapyDoctor>(this.drBooking + '/' + id).pipe(catchError(this.handleError));
  }
 
  getDoctorAvailableDates(id) {
    return this.http.get<PhysicalTherapyDoctor>(this.drUnAvailableDates + '/' + id).pipe(catchError(this.handleError));
  }
  updatePhysicalTherapyDoctor(id,body){
   return this.http.put<PhysicalTherapyDoctor>(this.url+'/'+id,body).pipe(catchError(this.handleError));
  }

  deletePhysicalTherapyDoctor(id){
return this.http.delete<PhysicalTherapyDoctor>(this.url+'/'+id).pipe(catchError(this.handleError));
  }



  
  
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error)
        return throwError(
          error.error
        )


      }
     else if(error.status ==401){
       return throwError('invalid username or password')

     }
      else if (error.status == 0) {
        return throwError(
          'network failure please try again later '
        )
      }
      return throwError(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };


}



